// Основной JavaScript файл темы
// Кнопка "подняться вверх"
document.addEventListener('DOMContentLoaded', function() {
    const scrollToTopBtn = document.getElementById('scrollToTopBtn');
    const page = document.querySelector('#page') || document.documentElement;
    
    if (!scrollToTopBtn) return;
    
    // Показываем кнопку с 15% прокрутки страницы
    function toggleScrollButton() {
        // Пробуем разные способы получения скролла
        let scrollTop = 0;
        let documentHeight = 0;
        
        // Сначала пробуем window
        scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        
        // Если window не работает, пробуем page элемент
        if (scrollTop === 0 && page && page.scrollTop !== undefined) {
            scrollTop = page.scrollTop;
            documentHeight = page.scrollHeight;
        } else {
            // Используем максимальную высоту документа
            documentHeight = Math.max(
                document.body.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.clientHeight,
                document.documentElement.scrollHeight,
                document.documentElement.offsetHeight
            );
        }
        
        const showPoint = documentHeight * 0.15; // 15% от высоты страницы
        
        if (scrollTop > showPoint) {
            scrollToTopBtn.classList.add('show');
        } else {
            scrollToTopBtn.classList.remove('show');
        }
    }
    
    // Обработчик скролла
    function handleScroll() {
        toggleScrollButton();
    }
    
    // Обработчик клика
    scrollToTopBtn.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        
        // Дополнительно пробуем через page, если есть
        if (page && page.scrollTo) {
            page.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    });
    
    // Привязываем обработчик скролла к обоим элементам
    if (page) {
        page.addEventListener('scroll', handleScroll);
    }
    
    // Всегда добавляем обработчик к window для надежности
    window.addEventListener('scroll', handleScroll);
    
    // Проверяем при загрузке
    toggleScrollButton();
});

// Заменяем текст "Закрыть" на SVG крестик в rey-searchPanel
function replaceCloseButtonText() {
    // Ищем кнопку закрытия в панели поиска
    const closeButton = document.querySelector('.rey-searchPanel .techno-right-menu__back');
    
    if (closeButton && !closeButton.hasAttribute('data-icon-replaced')) {
        console.log('Заменяем текст "Закрыть" на крестик в панели поиска');
        
        // Создаём SVG крестик
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', '18');
        svg.setAttribute('height', '18');
        svg.setAttribute('viewBox', '0 0 18 18');
        svg.setAttribute('fill', 'none');
        svg.style.cssText = 'display: block !important; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);';
        
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M4 4L14 14M14 4L4 14');
        path.setAttribute('stroke', 'white');
        path.setAttribute('stroke-width', '2');
        path.setAttribute('stroke-linecap', 'round');
        
        svg.appendChild(path);
        
        // Очищаем содержимое кнопки и добавляем SVG
        closeButton.innerHTML = '';
        closeButton.appendChild(svg);
        closeButton.setAttribute('data-icon-replaced', 'true');
        
        console.log('Крестик добавлен в панель поиска', svg);
    }
}

// Убираем <span> из текста "Ничего не найдено"
function cleanSearchResultsMessage() {
    const messageElement = document.querySelector('.rey-searchResults-message');
    
    if (!messageElement) {
        return;
    }
    
    if (messageElement.hasAttribute('data-cleaned')) {
        return;
    }
    
    let text = messageElement.innerHTML;
    const originalText = text;
    
    // Убираем <span> и </span> из текста
    text = text.replace(/&lt;span&gt;/gi, '');
    text = text.replace(/&lt;\/span&gt;/gi, '');
    text = text.replace(/<span>/gi, '');
    text = text.replace(/<\/span>/gi, '');
    
    if (text !== originalText) {
        messageElement.innerHTML = text.trim();
        messageElement.setAttribute('data-cleaned', 'true');
        console.log('✓ Очищено сообщение "Ничего не найдено"');
    }
}

// Отслеживаем появление сообщения "Ничего не найдено" через MutationObserver
function initSearchResultsObserver() {
    // Ищем панель поиска, где появляются результаты
    const searchPanel = document.querySelector('.rey-searchPanel');
    
    if (!searchPanel) {
        return;
    }
    
    // Создаём observer для отслеживания изменений
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            // Проверяем добавленные узлы
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) { // Элемент
                    // Проверяем, это ли наше сообщение
                    if (node.classList && node.classList.contains('rey-searchResults-message')) {
                        console.log('Обнаружено сообщение "Ничего не найдено"');
                        cleanSearchResultsMessage();
                    }
                    // Или проверяем внутри добавленного элемента
                    const message = node.querySelector('.rey-searchResults-message');
                    if (message) {
                        console.log('Обнаружено сообщение "Ничего не найдено" внутри элемента');
                        cleanSearchResultsMessage();
                    }
                }
            });
        });
    });
    
    // Начинаем наблюдение
    observer.observe(searchPanel, {
        childList: true,
        subtree: true
    });
    
    console.log('✓ Инициализирован observer для сообщений поиска');
}

// Обработчик для кнопок "часто ищут"
function initSearchKeywords() {
    const searchKeywordsContainer = document.querySelector('.techno-search-keywords');
    
    if (searchKeywordsContainer && !searchKeywordsContainer.hasAttribute('data-initialized')) {
        const buttons = searchKeywordsContainer.querySelectorAll('button');
        
        buttons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                const searchTerm = this.textContent.trim();
                
                // Формируем URL для поиска
                const searchUrl = `/?s=${encodeURIComponent(searchTerm)}&post_type=product`;
                
                console.log('Переход на поиск:', searchTerm, searchUrl);
                
                // Переходим на страницу поиска
                window.location.href = searchUrl;
            });
        });
        
        searchKeywordsContainer.setAttribute('data-initialized', 'true');
        console.log('Инициализированы кнопки "часто ищут":', buttons.length);
    }
}

// Обновляет иконку глаза в зависимости от типа input и класса --text
function updateEyeIcon(wrapper) {
    if (!wrapper) return;
    
    // Находим input внутри wrapper или рядом
    const passwordInputWrapper = wrapper.closest('.password-input') || wrapper.querySelector('.password-input');
    const input = passwordInputWrapper ? passwordInputWrapper.querySelector('input[type="password"], input[type="text"]') : null;
    
    if (!input) return;
    
    // Проверяем тип input и класс --text
    const passwordInputElement = wrapper.closest('.password-input') || wrapper.querySelector('.password-input');
    const isTextMode = input.type === 'text' || 
                      (passwordInputElement && passwordInputElement.classList.contains('--text')) ||
                      (wrapper.classList && wrapper.classList.contains('--text'));
    
    // Находим ВСЕ toggle внутри wrapper (и внутри password-input, и снаружи)
    const allToggleButtons = wrapper.querySelectorAll('.__passVisibility-toggle');
    
    // Также ищем toggle в родительском элементе (вне password-input)
    const parentWrapper = wrapper.closest('.__passVisibility-wrapper');
    if (parentWrapper) {
        const parentToggles = parentWrapper.querySelectorAll('.__passVisibility-toggle');
        
        // Объединяем все toggle
        const allToggles = new Set([...allToggleButtons, ...parentToggles]);
        
        allToggles.forEach((toggle, index) => {
            updateToggleIcon(toggle, isTextMode, index);
        });
    } else {
        if (allToggleButtons.length === 0) return;
        
        allToggleButtons.forEach((toggle, index) => {
            updateToggleIcon(toggle, isTextMode, index);
        });
    }
}

// Обновляет иконку в одном toggle
function updateToggleIcon(toggle, isTextMode, index) {
    // Ищем SVG внутри toggle
    const svg = toggle.querySelector('svg');
    if (!svg) return;
    
    // Проверяем текущее состояние - ищем line с классом eye-cross-line
    const hasLine = svg.querySelector('line.eye-cross-line');
    
    // Если состояние уже правильное, не меняем
    // isTextMode = true означает обычную иконку (без линии)
    // isTextMode = false означает перечеркнутую иконку (с линией)
    if ((isTextMode && !hasLine) || (!isTextMode && hasLine)) {
        return;
    }
    
    if (isTextMode) {
        // Удаляем линию перечеркивания
        const line = svg.querySelector('line.eye-cross-line');
        if (line) {
            line.remove();
        }
    } else {
        // Добавляем линию перечеркивания
        const existingLine = svg.querySelector('line.eye-cross-line');
        if (!existingLine) {
            // Всегда используем белый цвет для линии перечеркивания
            const lineColor = '#FFFFFF';
            
            // Используем line элемент для перечеркивания
            const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            line.setAttribute('class', 'eye-cross-line');
            line.setAttribute('x1', '25');
            line.setAttribute('y1', '25');
            line.setAttribute('x2', '437');
            line.setAttribute('y2', '321');
            line.setAttribute('stroke', lineColor);
            line.setAttribute('stroke-width', '50');
            line.setAttribute('stroke-linecap', 'round');
            line.setAttribute('opacity', '1');
            line.removeAttribute('fill');
            
            // Добавляем стиль для максимальной видимости
            line.style.setProperty('stroke', lineColor, 'important');
            line.style.setProperty('stroke-width', '50px', 'important');
            line.style.setProperty('opacity', '1', 'important');
            line.style.setProperty('fill', 'none', 'important');
            line.style.pointerEvents = 'none';
            
            // Убеждаемся, что линия находится вне группы g и в конце SVG
            const gElement = svg.querySelector('g');
            if (gElement && gElement.nextSibling) {
                svg.insertBefore(line, gElement.nextSibling);
            } else {
                svg.appendChild(line);
            }
        }
    }
}

// Инициализация переключения иконок глаза
function initPasswordEyeIcons() {
    // Находим все обертки паролей - ищем по родительскому wrapper
    const parentWrappers = document.querySelectorAll('.__passVisibility-wrapper');
    
    parentWrappers.forEach((parentWrapper) => {
        // Ищем внутри password-input wrapper
        const passwordWrapper = parentWrapper.querySelector('.__passVisibility-wrapper.password-input');
        if (passwordWrapper) {
            // Обновляем иконку при загрузке
            updateEyeIcon(passwordWrapper);
        
            // Находим input для отслеживания изменений типа
            const input = passwordWrapper.querySelector('input[type="password"], input[type="text"]');
        
            // Отслеживаем изменения типа input через периодическую проверку
            if (input) {
                let lastType = input.type;
                
                // Периодическая проверка типа input
                const checkInterval = setInterval(() => {
                    if (input.type !== lastType) {
                        lastType = input.type;
                        updateEyeIcon(passwordWrapper);
                    }
                }, 100);
                
                // Сохраняем interval для очистки при необходимости
                if (!passwordWrapper._eyeIconInterval) {
                    passwordWrapper._eyeIconInterval = checkInterval;
                }
            }
        
            // Отслеживаем изменения классов на родительском элементе password-input
            const passwordInput = passwordWrapper.closest('.password-input');
            if (passwordInput) {
                // Создаем observer для отслеживания изменений классов
                const classObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                            updateEyeIcon(passwordWrapper);
                        }
                    });
                });
            
                classObserver.observe(passwordInput, {
                    attributes: true,
                    attributeFilter: ['class']
                });
            
                // Также отслеживаем изменения классов на самом wrapper
                classObserver.observe(passwordWrapper, {
                    attributes: true,
                    attributeFilter: ['class']
                });
            }
        
            // Также отслеживаем клики на кнопки показа/скрытия пароля
            const toggleButtons = parentWrapper.querySelectorAll('button.show-password-input, .__passVisibility-toggle');
            toggleButtons.forEach(button => {
                // Проверяем, не добавлен ли уже обработчик
                if (button.hasAttribute('data-eye-icon-handler')) {
                    return;
                }
            
                button.setAttribute('data-eye-icon-handler', 'true');
            
                button.addEventListener('click', function(e) {
                    // Несколько проверок с задержками, чтобы поймать изменение типа
                    setTimeout(() => {
                        updateEyeIcon(passwordWrapper);
                    }, 10);
                    setTimeout(() => {
                        updateEyeIcon(passwordWrapper);
                    }, 50);
                    setTimeout(() => {
                        updateEyeIcon(passwordWrapper);
                    }, 100);
                });
            });
        }
    });
}

// Отслеживание динамически добавляемых элементов пароля
function initPasswordEyeIconsObserver() {
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) { // Элемент
                    // Проверяем, есть ли внутри новый элемент с паролем
                    const passwordWrappers = node.querySelectorAll 
                        ? node.querySelectorAll('.__passVisibility-wrapper.password-input')
                        : [];
                    
                    if (passwordWrappers.length > 0) {
                        passwordWrappers.forEach(wrapper => {
                            updateEyeIcon(wrapper);
                            
                            // Настраиваем observer для нового элемента
                            const passwordInput = wrapper.closest('.password-input');
                            if (passwordInput) {
                                const classObserver = new MutationObserver(function(mutations) {
                                    mutations.forEach(function(mutation) {
                                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                            updateEyeIcon(wrapper);
                                        }
                                    });
                                });
                                
                                classObserver.observe(passwordInput, {
                                    attributes: true,
                                    attributeFilter: ['class']
                                });
                            }
                        });
                    }
                    
                    // Проверяем, является ли сам узел оберткой пароля
                    if (node.classList && node.classList.contains('__passVisibility-wrapper') && node.classList.contains('password-input')) {
                        updateEyeIcon(node);
                    }
                }
            });
        });
    });
    
    // Наблюдаем за изменениями в документе
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

// Запускаем при загрузке
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM загружен, инициализация скриптов');
    replaceCloseButtonText();
    initSearchKeywords();
    cleanSearchResultsMessage();
    initSearchResultsObserver();
    initPasswordEyeIcons();
    initPasswordEyeIconsObserver();
});

// Запускаем с небольшой задержкой на случай динамической загрузки
setTimeout(replaceCloseButtonText, 100);
setTimeout(replaceCloseButtonText, 500);
setTimeout(replaceCloseButtonText, 1000);

setTimeout(initSearchKeywords, 100);
setTimeout(initSearchKeywords, 500);
setTimeout(initSearchKeywords, 1000);

setTimeout(cleanSearchResultsMessage, 100);
setTimeout(cleanSearchResultsMessage, 500);
setTimeout(cleanSearchResultsMessage, 1000);

setTimeout(initSearchResultsObserver, 100);
setTimeout(initSearchResultsObserver, 500);

setTimeout(initPasswordEyeIcons, 100);
setTimeout(initPasswordEyeIcons, 500);
setTimeout(initPasswordEyeIcons, 1000);
